import { useState, Fragment, useRef } from "react";

import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import moment from "moment";

import { getInvestmentCurrencies } from "../../../custom-hooks/useInvestmentCurrencies";
import { postDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import Financials from "./CreateInvestmentsViews/Financials";
import Alert from "../../../NewComponents/Alert/Alert.component";
import { errorHandler } from "../../../helpers/errorHandler";
import { ReactComponent as Cancel } from "../../../assets/svg/icons/cancel.svg";
import CreateInvestmentModal from "./CreateInvestmentModal/CreateInvestmentModal";
import { ROLE_TYPES } from "./../../../helpers/roleTypes";
import { appInsights } from "../../../config/appInsights";
import CustomSearchDropDown from "../../CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";
import Loader from "../../../NewComponents/Loader/Loader.component";

import styles from "./InvestmentProduct.module.scss";

const CreateInvestmentProduct = (props) => {
  const [modalActionType, setModalActionType] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [saveDraftError, setSaveDraftError] = useState(null);

  const getOptions = () => {
    return new Promise((resolve, reject) => {
      getInvestmentCurrencies()
        .then((data) => {
          resolve(
            data?.data.map((detail) => ({
              value: detail?.currency_code,
              label: detail?.currency_name,
            }))
          );
        })
        .catch(reject);
    });
  };

  const handleDropdownChange = (data) => {
    return setState((prev) => ({
      ...prev,
      investment_product_details: [...data],
    }));
  };

  const [state, setState] = useState({
    name: "",
    start_date: "",
    end_date: "",
    objective: "",
    issuers: "",
    description: "",
    target_investors: "",
    investment_product_details: [],
  });
  const dismissModalRef = useRef();

  const history = useHistory();

  const handleSubmitDraft = async () => {
    setLoading(true);
    const reqBody = { ...state };

    // remove unwanted propertes from the payload
    const refinedProductDetails = reqBody.investment_product_details.map(
      (item) => ({
        core_banking_product_id: Number(item?.core_banking_product_id),
        core_banking_tenant_id: item?.core_banking_tenant_id,
        currency_code: item?.currency_code,
        maximum_investment: Number(item?.maximum_investment),
        minimum_investment: Number(item?.minimum_investment),
        investment_size: Number(item?.investment_size),
      })
    );

    reqBody.investment_product_details = refinedProductDetails;
    reqBody.start_date = moment(reqBody?.start_date).format("DD/MM/YYYY");
    reqBody.end_date = moment(reqBody?.end_date).format("DD/MM/YYYY");

    try {
      const response = await postDataWithDotNet(
        ajaxEndpoints.FUNDER_INVESTMENT_PRODUCT,
        reqBody
      );

      setSuccessMessage(response.message);
      setTimeout(() => {
        history.push("/investments");
      }, 3000);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "CreateInvestmentProduct.jsx",
        },
      });

      setSaveDraftError(errorHandler(error));
      setTimeout(() => {
        setSaveDraftError(null);
      }, 3000);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState({ ...state, [name]: value });
  };

  const discardChanges = (e) => {
    e.preventDefault();
    if (dismissModalRef && dismissModalRef.current) {
      dismissModalRef.current.click();
    }
    setState({
      name: "",
      objective: "",
      issuers: "",
      description: "",
      target_investors: "",
      start_date: "",
      end_date: "",
      investment_product_details: [],
    });
  };

  return (
    <Fragment>
      <div
        className={`animated fadeInRight mt-2 ${styles.createInvestmentProduct}`}
      >
        <span
          disabled={loading}
          data-toggle="modal"
          data-target="#createInvestmentModal"
          onClick={() => setModalActionType("cancel")}
        >
          <Cancel /> <span className="cancel-title ml-1">Cancel</span>
        </span>
        <div className="d-flex flex-row flex-wrap mt-3 mb-1">
          {saveDraftError && <Alert message={saveDraftError} />}
          {successMessage && <Alert message={successMessage} type="success" />}
          <h3 className="page-title">Create New Fund</h3>

          <div className="d-flex flex-row flex-wrap justify-content-end">
            {props.loggedInUser.roleTypes.includes(
              ROLE_TYPES.INVESTMENT_PRODUCT_SETUP
            ) ? (
              <div>
                <button
                  type="submit"
                  className="btn advancly-white-btn btn-md m-0"
                  onClick={handleSubmitDraft}
                  disabled={loading}
                >
                  Save & Submit
                  {loading && <Loader />}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <h3 className="page-subtitle mb-3 ml-3">Investment Details</h3>
        <form>
          <div className="row col-6 col-md-8 col-sm-8">
            <div className="col-md-12 mt-1">
              <label className="label-txt">Name of Fund</label>
              <input
                className="form-control"
                value={state.name}
                name="name"
                onChange={(e) => handleChange(e)}
              />
            </div>

            <div className={styles.productBasicDetails}>
              <div className="col-md-6">
                <label>Start date: </label>
                <input
                  type="date"
                  name="start_date"
                  className="form-control"
                  value={state.start_date}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6">
                <div>
                  <label>End date: </label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={state.end_date}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-md-6 mt-3 pl-2">
                <label className="label-txt">Description</label>
                <input
                  className="form-control"
                  value={state.description}
                  name="description"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label className="label-txt">Objective</label>
                <input
                  className="form-control"
                  value={state.objective}
                  name="objective"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6 mt-3 pl-2">
                <label className="label-txt">Issuer</label>
                <input
                  className="form-control"
                  value={state.issuers}
                  name="issuers"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label className="label-txt">Target Investor</label>
                <input
                  className="form-control"
                  value={state.target_investors}
                  name="target_investors"
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>

            <hr className={styles.divider}></hr>

            <div className="col-md-12 my-3">
              <label className="label-txt">
                What currencies are you accepting for this fund:
              </label>

              <div className="col-md-12 p-0">
                <CustomSearchDropDown
                  label="Select Currency"
                  onChange={handleDropdownChange}
                  loadOptions={getOptions}
                  defaultOptions={true}
                  name="user"
                  isShowLabel={false}
                  isMulti={true}
                  isSearchable={false}
                />
              </div>
            </div>

            <div className={styles.financialsContainer}>
              <div className="col-md-12">
                <h3 className="page-subtitle mb-2">Currencies:</h3>
              </div>
              {state?.investment_product_details.length < 1 && (
                <div className={styles.noCurrencyErrorContainer}>
                  You have not selected any currencies
                </div>
              )}
              {state?.investment_product_details.map((item, index) => (
                <Financials
                  key={index}
                  handleChange={handleChange}
                  state={state}
                  setState={setState}
                  selectedProductDetails={item}
                />
              ))}
            </div>
          </div>
        </form>
      </div>
      <CreateInvestmentModal
        onSubmit={handleSubmitDraft}
        discardChanges={discardChanges}
        modalActionType={modalActionType}
        dismissModalRef={dismissModalRef}
        loading={loading}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const { loggedInUser } = state.authReducer;

  return {
    loggedInUser,
  };
};

export default withRouter(connect(mapStateToProps)(CreateInvestmentProduct));
